import UserType from 'constants/userType'
import ExternalCardProvider from 'constants/externalCardProvider'
import userActions from 'store/user'
import api from '../api/api'
import Token from '../api/auth-token-wrapper'

const mapExternalCardProvider = (value) => {
  if (value === ExternalCardProvider.SHELL) {
    return ExternalCardProvider.SHELL
  }
  return null
}

export default async (dispatch, successCallback, errorCallback) => {
  dispatch(userActions.setUserLoading(true))

  // We have to refresh/reload only if the token was added already.
  let shouldRefresh = Token.getToken()

  try {
    const response = await api.user.getLoggedUser()
    dispatch(userActions.setUserData({
      ...response.data,
      externalCardUse: mapExternalCardProvider(response.data.externalCardUse),
    }))
    dispatch(userActions.setUserIsLogged(true))

    const lead = await api.user.getAccount()
    dispatch(
      userActions.setUserData({
        salutation: lead.data.salutation,
        language: lead.data.language,
        type: lead.data.type,
      })
    )

    successCallback && successCallback(lead.data.type === UserType.EMPLOYEE)
  } catch (error) {
    if (!is401Error(error)) {
      try {
        const response = await api.auth.refreshToken()
        Token.setAuthTokens(response.data)
        shouldRefresh = Token.getToken()
        try {
          const userDataResponse = await api.user.getLoggedUser()
          dispatch(userActions.setUserIsLogged(true))
          dispatch(userActions.setUserData({
            ...userDataResponse.data,
            externalCardUse: mapExternalCardProvider(userDataResponse.data.externalCardUse),
          }))
          const lead = await api.user.getAccount()
          dispatch(
            userActions.setUserData({
              salutation: lead.data.salutation,
              language: lead.data.language,
              type: lead.data.type,
            })
          )

          successCallback &&
            successCallback(lead.data.type === UserType.EMPLOYEE)
        } catch (error) {
          if (is401Error(error)) {
            // Remove token.
            removeAndReload(shouldRefresh)
          }

          dispatch(userActions.resetUser()) // note that we shouldn't remove the tokens at this point, because perhaps the api call failed due to internet connectivity
          errorCallback && errorCallback(error)
        }
      } catch (error) {
        if (is401Error(error)) {
          // Remove token.
          removeAndReload(shouldRefresh)
        }
        dispatch(userActions.resetUser()) // note that we shouldn't remove the tokens at this point, because perhaps the api call failed due to internet connectivity
        errorCallback && errorCallback(error)
      }
    } else {
      // Remove token.
      removeAndReload(shouldRefresh)
      errorCallback && errorCallback(error)
    }
  }

  dispatch(userActions.setUserLoading(false))
}

const removeAndReload = (shouldReload) => {
  // Preserve SSO cookie to allow calling code to decide how to proceed
  Token.removeLocalStorageTokensOnly()
  // If SSO cookie exists, avoid reloading to prevent redirect loops.
  // The caller (e.g., App.tsx) will handle clearing the cookie and redirection.
  if (Token.getSSoToken()) {
    return
  }
  if (shouldReload) {
    window.location.reload()
  }
}

const is401Error = (error) => {
  // More precise check for 401 errors - check status code directly
  return error && error.response && error.response.status === 401
}
